/**
 * BackOffice Auth API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";

import { Observable } from "rxjs";

import { BaseService } from "../api.base.service";
import { Configuration } from "../configuration";
// @ts-ignore
import { AuthForgotPasswordPostRequest } from "../model/authForgotPasswordPostRequest";
// @ts-ignore
import { ConfirmEmailRequest } from "../model/confirmEmailRequest";
// @ts-ignore
import { ResetPasswordRequest } from "../model/resetPasswordRequest";
import { OpenApiHttpParams, QueryParamStyle } from "../query.params";
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from "../variables";

@Injectable({
  providedIn: "root",
})
export class AccountApi extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration
  ) {
    super(basePath, configuration);
  }

  /**
   * Confirm email / activate account from an emailed link
   * Client portal additionally verifies the last four digits of the phone number (lastFourNumbersOfPhone).
   * @endpoint post /auth/confirm-email
   * @param confirmEmailRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public authConfirmEmailPost(
    confirmEmailRequest: ConfirmEmailRequest,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any>;
  public authConfirmEmailPost(
    confirmEmailRequest: ConfirmEmailRequest,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<any>>;
  public authConfirmEmailPost(
    confirmEmailRequest: ConfirmEmailRequest,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<any>>;
  public authConfirmEmailPost(
    confirmEmailRequest: ConfirmEmailRequest,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (confirmEmailRequest === null || confirmEmailRequest === undefined) {
      throw new Error(
        "Required parameter confirmEmailRequest was null or undefined when calling authConfirmEmailPost."
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(["application/json"]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Content-Type",
        httpContentTypeSelected
      );
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/auth/confirm-email`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>("post", `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: confirmEmailRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined
        ? { transferCache: localVarTransferCache }
        : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Request a password-reset email
   * Always returns 204 (no user enumeration).
   * @endpoint post /auth/forgot-password
   * @param authForgotPasswordPostRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public authForgotPasswordPost(
    authForgotPasswordPostRequest: AuthForgotPasswordPostRequest,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any>;
  public authForgotPasswordPost(
    authForgotPasswordPostRequest: AuthForgotPasswordPostRequest,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<any>>;
  public authForgotPasswordPost(
    authForgotPasswordPostRequest: AuthForgotPasswordPostRequest,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<any>>;
  public authForgotPasswordPost(
    authForgotPasswordPostRequest: AuthForgotPasswordPostRequest,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (
      authForgotPasswordPostRequest === null ||
      authForgotPasswordPostRequest === undefined
    ) {
      throw new Error(
        "Required parameter authForgotPasswordPostRequest was null or undefined when calling authForgotPasswordPost."
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Content-Type",
        httpContentTypeSelected
      );
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/auth/forgot-password`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>("post", `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: authForgotPasswordPostRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined
        ? { transferCache: localVarTransferCache }
        : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Set a new password using a token from the reset email
   * @endpoint post /auth/reset-password
   * @param resetPasswordRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public authResetPasswordPost(
    resetPasswordRequest: ResetPasswordRequest,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any>;
  public authResetPasswordPost(
    resetPasswordRequest: ResetPasswordRequest,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<any>>;
  public authResetPasswordPost(
    resetPasswordRequest: ResetPasswordRequest,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<any>>;
  public authResetPasswordPost(
    resetPasswordRequest: ResetPasswordRequest,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (resetPasswordRequest === null || resetPasswordRequest === undefined) {
      throw new Error(
        "Required parameter resetPasswordRequest was null or undefined when calling authResetPasswordPost."
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(["application/json"]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Content-Type",
        httpContentTypeSelected
      );
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/auth/reset-password`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>("post", `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: resetPasswordRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined
        ? { transferCache: localVarTransferCache }
        : {}),
      reportProgress: reportProgress,
    });
  }
}
